/**
 * TGFM Premium Scroll Animations
 * Attiva animazioni quando gli elementi entrano nel viewport
 */

(function() {
  'use strict';

  // Configurazione
  const config = {
    threshold: 0.1, // 10% dell'elemento visibile
    rootMargin: '0px 0px -50px 0px' // Trigger un po' prima
  };

  // Intersection Observer per animazioni scroll
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        // Opzionale: osserva solo una volta
        // observer.unobserve(entry.target);
      }
    });
  }, config);

  // Funzione per inizializzare le animazioni
  function initScrollAnimations() {
    // Seleziona tutti gli elementi con classi animabili
    const animatedElements = document.querySelectorAll(
      '.fade-in-up, .fade-in, .scale-in'
    );

    // Osserva ogni elemento
    animatedElements.forEach(el => {
      observer.observe(el);
    });

    // Log per debug
    if (animatedElements.length > 0) {
      console.log(`[TGFM] ${animatedElements.length} elementi con scroll animation inizializzati`);
    }
  }

  // Inizializza quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  // Re-inizializza dopo caricamenti dinamici (Shopify sections, AJAX)
  document.addEventListener('shopify:section:load', initScrollAnimations);

  // Esponi funzione globale per uso manuale
  window.TGFM = window.TGFM || {};
  window.TGFM.initScrollAnimations = initScrollAnimations;

})();
